import { routes } from "../../../constants/routes";

const core = {
  public: {
    title: "Los primeros siempre juegan con ventaja",
    description: "Únete hoy y GANA un ",
    span1: "BONO",
    description2: " de bienvenida por ser parte de la familia ",
    span2: "POWERBET",
    button: "REGISTRATE YA",
    carousel: [
      {
        title: "CONVIÉRTETE EN UN VIP",
        description: "Siente los beneficios de ser un jugador vip",
        link: routes.VIP,
        textLink: "Saber más",
        img: "/img/v2/home/crown.webp"
      },
      {
        title: "BONOS Y MUCHOS MÁS",
        description: "Por que nos gusta que estes bien y generes ingresos.",
        link: routes.PROMOTIONS,
        textLink: "Saber más",
        img: "/img/v2/home/gift.webp"
      },
      {
        title: "JACKPOT SORPRESA",
        description: "Los Jackpots caen al azar. ¡Juega y gana el tuyo!",
        link: routes.JACKPOTS,
        textLink: "Saber más",
        img: "/img/v2/home/casinoCoin.webp"
      }
    ],
    casino: {
      title: {
        casino: "Casino",
        zinga: "Exclusivos para ti",
        favorites: "Tus favoritos"
      },
      link: routes.CASINO,
      textLink: "Saber más",
      error: {
        title: "Error al cargar juegos",
        description: "No se pudieron cargar los juegos de casino. Por favor, intenta de nuevo.",
        button: "Intentar de nuevo"
      },
      empty: {
        title: "Aún no tienes favoritos",
        description: "Marca juegos con la estrella para verlos aquí."
      },
      emptyCatalog: {
        title: "No hay juegos disponibles",
        description: "Vuelve a intentarlo más tarde."
      }
    },
    challenges: {
      title: "DESAFÍO DE LA SEMANA",
      description: "Todos nuestros usuarios",
      span: "POWERBET",
      description2: "están pendientes de nuestros desafíos, ya que es una de las formas de aumentar sus",
      span2: "ganancias hasta X5.",
      link: routes.PROMOTIONS,
      textLink: "SABER MÁS"
    },
    cms: {
      title: "Lo mejor del mes..."
    },
    descriptionSection: {
      title: "Pronósticos Deportivos y Casino en línea con",
      span: "Powerbet.la",
      less: "Leer menos",
      more: "Leer más",
      description: "En Powerbet.la encuentras pronósticos deportivos, casino online y juegos en una sola plataforma pensada para Latinoamérica. Operamos bajo la License No. ALSI-032401020-FI3, con tecnología segura y confiable para que juegues con total tranquilidad.",
      // eslint-disable-next-line max-len
      description3:
        "En Powerbet.la puedes hacer tus pronosticos deportivas con más 100 eventos deportivos al día. Es tu momento de pronosticar, retarte a ti mismo y a tus amigos a adivinar los marcadores exactos, ganadores y muchos más mercados dentro de un mismo evento deportivo. Te enfrentarás a escenarios tales como, ¿Qué equipo ganará? ¿Quién marcará más goles? ¿Quién clasificará a la siguiente ronda? O ¿Cuántos puntos se anotarán? Además de contar con las cuotas más altas y competitivas de todo latinoamerica.",
      list: ["pronosticos deportivas en fútbol en vivo", "pronosticos en Liga de México (Liga MX)", "pronosticos en Champions League", "pronosticos en NBA", "pronosticos en tenis", "pronosticos en NFL", "pronosticos en Boxeo"],
      description4: "Y muchos más deportes, con diferentes mercados en los que podrás jugar, apostar y pronosticar desde tu casa o desde cualquier lugar en el que te encuentres.",
      description5: "pronosticos Deportivas en vivo y Casino en línea en Powerbet.la",
      description6: "Powerbet.la ofrece la mejor experiencia, un amplio repertorio de pronosticos en casino en línea. Juega y gana dinero real en el casino virtual de Powerbet.la de forma segura y divertida.",
      description7: "Tenemos una amplia gama de juegos de casino, son más de 200 opciones en las que se incluyen tragamonedas, ruleta, blackjack, bingo, póker, casino en vivo y rueda de la fortuna. Empieza hoy a disfrutar de los mejores juegos del mercado, con gráficos y premios increíbles.",
      description8: "¿Cómo apostar en Powerbet.la? Paso a paso de como ganar dinero con pronosticos Deportivos en latinoamerica",
      description9: "Es momento de disfrutar y ganar dinero con Powerbet.la, fácil sigue está guía rápida:",
      list2: [
        "Debes ser mayor de 21 años y registrarte en Powerbet.la, asegúrate de poner tus datos personales precisos y verificar tu cuenta. Recibirás un bono por tu registro sin depósito.",
        "Realiza tu primer depósito para empezar a apostar, además recibirás un bono por tu primera recarga, aprovéchalo.",
        "Elige tu deporte, liga y evento favorito para apostar y ganar dinero."
      ],
      description10: " pronosticos deportivas de fútbol en Powerbet.la: Cuotas, mercados y métodos de Pronostico explicados.",
      description11: "El fútbol es el deporte con mayor popularidad en el mundo y también el más apostado en las pronosticos deportivas. Acá te explicamos los mercados más comunes:",
      list3: [
        {
          title: "1x2 (1 es local, X es empate, 2 es visitante):",
          description: "1x2 es el mercado por excelencia de las pronosticos deportivas en fútbol, si te decides por este mercado tendrás que elegir uno de los 3."
        },
        {
          title: "Ambos equipos marcan:",
          description: "Es aquella Pronostico donde pronósticas que ambos equipos anotarán gol. Por ejemplo, si juega Colombia contra México y el partido finaliza 3-1 a favor de La H, acertarás tu Pronostico si pronosticas que ambos equipos anotarán gol."
        },
        {
          title: "Total de goles:",
          description: "Consiste en pronosticar cuál es la cantidad de goles que habrá en un determinado partido."
        },
        {
          title: "Primer gol:",
          description: "Pronostico a que un equipo marcará el primer gol. Si pronosticas 200 y la cuota es de 2.0 ganarás 400."
        }
      ],
      subtitle1: "Tipos de pronosticos deportivas en Powerbet.la",
      list4: [
        {
          title: "pronosticos simples",
          description:
            "El pronostico simple o sencilla consiste en escoger un un evento deportivo y seleccionar un único mercado y resultado para dicho evento. Elige tu mercado, ingresa el valor que desees apostar y confirma tu Pronostico. Recuerda siempre que las ganancias se calculan multiplicando la cantidad jugada por la cuota."
        },
        {
          title: "pronosticos combinadas o Parlay (Parley)",
          description: "En esta modalidad de Pronostico podrás combinar varios resultados en diferentes eventos. Podrás juntar hasta 15 partidos de diferentes deportes y las cuotas se multiplicarán entre si, lo que aumentará exponencialmente tus ganancias."
        },
        {
          title: "Bono de registro en Powerbet.la: Recibe 100 o 100 jugadas gratis de casino y sin depósito.",
          description: "En Powerbet.la tu eliges tu regalo, de esta manera te damos la mejor de las bienvenidas. Lo único que debes hacer es registrarte, verificar tu cuenta y disfrutar de tus primeras pronosticos con este bono exclusivo de bienvenida. Consulta aquí los términos y condiciones con cada detalle."
        },
        {
          title: "Bono de primer depósito en Powerbet.la: Recibe el 100% de tu primer depósito.",
          description: "Duplica tu primer depósito en Powerbet.la. Por tu primera recarga desde 250 ganarás el doble de este. Para empezar a ganar en la mejor plataforma de pronosticos deportivas y casino."
        }
      ]
    },
    sport: {
      title: "Deportes",
      link: routes.SPORTS,
      textLink: "Saber más",
      games: [
        {
          title: "Torneo de fútbol",
          provider: "Torneo de fútbol",
          img: "/img/v2/home/Toneos.webp",
          url: `${routes.SPORTS}#/sport/75`,
          imgText: "Torneos",
          icon: "/img/v2/icons/trophy.svg"
        },
        {
          title: "Partido de fútbol",
          provider: "Partido de fútbol",
          img: "/img/v2/home/Futbol.webp",
          url: `${routes.SPORTS}#/sport/66`,
          imgText: "Fútbol",
          icon: "/img/v2/icons/ball.svg"
        },
        {
          title: "Partido de baloncesto",
          provider: "Partido de baloncesto",
          img: "/img/v2/home/Basket.webp",
          url: `${routes.SPORTS}#/sport/67`,
          imgText: "Baloncesto",
          icon: "/img/v2/icons/basketball.svg"
        },
        {
          title: "Partido de tenis",
          provider: "Partido de tenis",
          img: "/img/v2/home/Tennis.webp",
          url: `${routes.SPORTS}#/sport/68`,
          imgText: "Tenis",
          icon: "/img/v2/icons/tennis.svg"
        },
        {
          title: "Partido de béisbol",
          provider: "Béisbol",
          img: "/img/v2/home/Baseball.webp",
          url: `${routes.SPORTS}#/sport/76`,
          imgText: "Béisbol",
          icon: "/img/v2/icons/baseball.svg"
        },
        {
          title: "boxeo",
          provider: "Boxeo",
          img: "/img/v2/home/box.webp",
          url: routes.SPORTS,
          imgText: "Boxeo",
          icon: "/img/v2/icons/boxeo.svg"
        },
        {
          title: "ciclismo",
          provider: "Ciclismo",
          img: "/img/v2/home/cicly.webp",
          url: routes.SPORTS,
          imgText: "Ciclismo",
          icon: "/img/v2/icons/cicly.svg"
        },
        {
          title: "rugby",
          provider: "Rugby",
          img: "/img/v2/home/rugby.webp",
          url: routes.SPORTS,
          imgText: "Rugby",
          icon: "/img/v2/icons/rugby.svg"
        },
        {
          title: "hockey",
          provider: "Hockey",
          img: "/img/v2/home/hockey.webp",
          url: routes.SPORTS,
          imgText: "Hockey",
          icon: "/img/v2/icons/hockey.svg"
        }
      ]
    }
  }
};
export default core;
